import { Title } from "@/components/commons/typography/Title"
import { DealSyncSideBarModalBase } from "./DealSyncSideBarModalBase"
import { Modal } from "@/components/modal/Modal"
import { useContext } from "react"
import { BrowserContext } from "context"
import { Text } from "@/components/commons/typography/Text"
import { ButtonComponent } from "@/components/commons"

interface DealSyncSideBarModalConnectProps {
  isOpen: boolean
  onClose: () => void
}

export const DealSyncSideBarModalConnected = ({ isOpen, onClose }: DealSyncSideBarModalConnectProps) => {
  const { isMobile } = useContext(BrowserContext)
  return (
    <Modal
      styles={{
        body: {
          padding: 0,
          background: 'transparent',
        },
        content: {
          background: 'transparent',
          overflow: 'visible',
          minWidth: !isMobile ? '500px' : undefined
        }
      }}
      centered
      size="md"
      opened={isOpen} onClose={onClose} withCloseButton={false}>
      <DealSyncSideBarModalBase>
 
        <Title
          variation='regular'
          sizeClass="text-18"
          lineHeightClass="leading-22"
          // weightClass="font-light"
          className='text-center'>
            You're in! We're scanning your inbox for VIP connections.
        </Title>

        <Text className="text-center mt-22">
          Our system is now analyzing your past conversations to uncover hidden dealmakers — brands, agencies, collaborators, and creators you’ve already worked with or had contact with in the past.
        </Text>
        <Text className="text-center mt-22">
          We’ll notify you by email once your VIP connections are ready, and you can track your progress anytime in Creatorland.
        </Text>

        <div className="flex full-w justify-center mt-22">
          <ButtonComponent
            size="regular"
            label="Let's do this!"
            fullWidth
            onClick={onClose}
          />
        </div>
      </DealSyncSideBarModalBase>
    </Modal>
  )
}